/**
 * Uncanned subscription builder.
 * Talks to the Railway backend, never to the Shopify cart. See section comment in
 * sections/uncanned-subscription.liquid for the flow.
 */
(function () {
  'use strict';

  var root = document.getElementById('sub-root');
  if (!root) return;

  var cfg = {
    api: root.dataset.apiBase.replace(/\/$/, ''),
    shop: root.dataset.shop,
    seatsTotal: parseInt(root.dataset.seatsTotal, 10) || 25,
    mock: root.dataset.mock === 'true',
    showSeats: root.dataset.showSeats === 'true',
    bluPrefix: root.dataset.bengaluruPrefix || '560',
    samedayText: root.dataset.samedayText,
    shipsText: root.dataset.shipsText,
    ctaText: root.dataset.ctaText,
    fullText: root.dataset.fullText
  };

  var plans = [];
  try { plans = JSON.parse(document.getElementById('sub-plans').textContent); } catch (e) { plans = []; }

  var state = { flavour: null, pack: null, cadence: null, seatsLeft: null, busy: false };

  var els = {
    packs: document.getElementById('sub-packs'),
    cadence: document.getElementById('sub-cadence'),
    flavours: Array.prototype.slice.call(document.querySelectorAll('#sub-flavours .sub-flavour')),
    barCount: document.getElementById('sub-bar-count'),
    barPrice: document.getElementById('sub-bar-price'),
    cont: document.getElementById('sub-continue'),
    seats: document.getElementById('sub-seats'),
    modal: document.getElementById('sub-modal'),
    summary: document.getElementById('sub-modal-summary'),
    form: document.getElementById('sub-form'),
    delivery: document.getElementById('sub-delivery'),
    error: document.getElementById('sub-error'),
    pay: document.getElementById('sub-pay'),
    cancel: document.getElementById('sub-cancel')
  };

  root.dataset.payText = els.pay.textContent;

  function rupees(n) { return '₹' + Number(n).toLocaleString('en-IN'); }
  function flavourCard() { return els.flavours.filter(function (c) { return c.dataset.handle === state.flavour; })[0] || null; }
  function plan() {
    if (!state.pack || !state.cadence) return null;
    return plans.filter(function (p) { return p.pack === state.pack && p.cadence === state.cadence; })[0] || null;
  }
  function cadenceLabel(c) { return c === '2w' ? 'every 2 weeks' : 'every 4 weeks'; }
  function seatsFull() { return state.seatsLeft !== null && state.seatsLeft <= 0; }

  function render() {
    var p = plan(), card = flavourCard();
    els.flavours.forEach(function (c) { c.setAttribute('aria-pressed', String(c.dataset.handle === state.flavour)); });
    els.packs.querySelectorAll('.sub-chip').forEach(function (b) { b.setAttribute('aria-pressed', String(parseInt(b.dataset.pack, 10) === state.pack)); });
    els.cadence.querySelectorAll('.sub-chip').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.cadence === state.cadence)); });

    var parts = [];
    if (card) parts.push(card.dataset.name);
    if (state.pack) parts.push(state.pack + ' cans');
    if (state.cadence) parts.push(cadenceLabel(state.cadence));
    els.barCount.textContent = parts.length ? parts.join(' · ') : 'Pick a flavour';

    if (p && p.price) {
      els.barPrice.innerHTML = (p.compare ? '<s>' + rupees(p.compare) + '</s>' : '') + rupees(p.price) + ' per box · gift in every 3rd box';
    } else if (state.pack && state.cadence) {
      els.barPrice.textContent = 'Price coming soon for this pack';
    } else {
      els.barPrice.textContent = 'Choose a pack and a rhythm to see the price';
    }
    var ready = card && p && p.price > 0;
    els.cont.disabled = !ready || state.busy;
    els.cont.textContent = seatsFull() ? cfg.fullText : cfg.ctaText;
    if (state.seatsLeft !== null) {
      els.seats.textContent = seatsFull() ? 'First lot of ' + cfg.seatsTotal + ' is full' : state.seatsLeft + ' of ' + cfg.seatsTotal + ' founding seats left';
      els.seats.hidden = false;
    }
  }

  function setPack(n) { state.pack = n; render(); }

  els.flavours.forEach(function (card) {
    card.addEventListener('click', function () { state.flavour = card.dataset.handle; render(); });
  });
  els.packs.addEventListener('click', function (e) {
    var b = e.target.closest('.sub-chip'); if (!b) return;
    setPack(parseInt(b.dataset.pack, 10));
  });
  els.cadence.addEventListener('click', function (e) {
    var b = e.target.closest('.sub-chip'); if (!b) return;
    state.cadence = b.dataset.cadence; render();
  });

  // ---- Prefill from query string (WhatsApp links) and signed-in customer ----
  (function prefill() {
    var q = new URLSearchParams(location.search);
    var pack = parseInt(q.get('pack'), 10);
    if ([6, 12, 24].indexOf(pack) !== -1) setPack(pack);
    var cad = q.get('cadence');
    if (cad === '2w' || cad === '4w') state.cadence = cad;
    if (cad === '2' || cad === '4') state.cadence = cad + 'w';
    var fl = (q.get('flavour') || q.get('flavours') || '').toLowerCase();
    if (fl) {
      var match = els.flavours.filter(function (c) { return c.dataset.handle === fl || c.dataset.product === fl || c.dataset.name.toLowerCase() === fl; })[0];
      if (match) state.flavour = match.dataset.handle;
    }
    var f = els.form;
    f.name.value = q.get('name') || root.dataset.customerName || '';
    f.phone.value = (q.get('phone') || root.dataset.customerPhone || '').replace(/^\+?91/, '').replace(/\D/g, '');
    f.email.value = root.dataset.customerEmail || '';
    render();
  })();

  // ---- Seats ----
  function loadSeats() {
    // Never invent a number. The badge shows only with a real count from the backend.
    if (!cfg.showSeats || cfg.mock) { state.seatsLeft = null; els.seats.hidden = true; return; }
    fetch(cfg.api + '/api/subscriptions/seats').then(function (r) { return r.json(); }).then(function (d) {
      state.seatsLeft = typeof d.seatsLeft === 'number' ? d.seatsLeft : null;
      if (typeof d.seatsTotal === 'number') cfg.seatsTotal = d.seatsTotal;
      render();
    }).catch(function () { /* seats badge simply stays hidden */ });
  }
  loadSeats();

  // ---- Modal ----
  function openModal() {
    var p = plan();
    var card = flavourCard();
    els.summary.textContent = card.dataset.name + ' · ' + state.pack + ' cans ' + cadenceLabel(state.cadence) + ' · ' + rupees(p.price) + ' per box';
    els.error.textContent = '';
    els.form.hidden = false;
    els.modal.hidden = false;
    document.body.style.overflow = 'hidden';
    els.form.name.focus();
  }
  function closeModal() { els.modal.hidden = true; document.body.style.overflow = ''; }
  // Hosted route: when the plan has a Razorpay Payment Page URL, skip our form and
  // send the customer straight there. Razorpay collects details and sets up the mandate.
  function openHosted(p) {
    var card = flavourCard();
    var q = new URLSearchParams(location.search);
    var url = new URL(p.url, location.href);
    var name = (els.form.name.value || q.get('name') || '').trim();
    var phone = (els.form.phone.value || '').replace(/\D/g, '');
    if (name) url.searchParams.set('name', name);
    if (phone.length === 10) url.searchParams.set('contact', phone);
    if (els.form.email.value) url.searchParams.set('email', els.form.email.value.trim());
    url.searchParams.set('notes[flavour]', card ? card.dataset.name : '');
    url.searchParams.set('notes[plan]', p.key);
    if (q.get('src')) url.searchParams.set('notes[source]', q.get('src'));
    location.href = url.toString();
  }
  els.cont.addEventListener('click', function () {
    var p = plan();
    if (p && p.url) { openHosted(p); return; }
    openModal();
  });
  els.cancel.addEventListener('click', closeModal);
  els.modal.addEventListener('click', function (e) { if (e.target === els.modal) closeModal(); });

  els.form.pincode.addEventListener('input', function () {
    var v = els.form.pincode.value.replace(/\D/g, '').slice(0, 6);
    els.form.pincode.value = v;
    if (v.length !== 6) { els.delivery.textContent = ''; els.delivery.className = 'sub-delivery'; return; }
    var blu = v.indexOf(cfg.bluPrefix) === 0;
    els.delivery.textContent = blu ? cfg.samedayText : cfg.shipsText;
    els.delivery.className = 'sub-delivery' + (blu ? ' ok' : '');
    if (blu && !els.form.city.value) { els.form.city.value = 'Bengaluru'; els.form.state.value = 'Karnataka'; }
  });

  function customer() {
    var f = els.form;
    var phone = f.phone.value.replace(/\D/g, '').replace(/^91(?=\d{10}$)/, '');
    return {
      name: f.name.value.trim(), phone: '+91' + phone, email: f.email.value.trim(),
      address1: f.address1.value.trim(), address2: f.address2.value.trim(),
      city: f.city.value.trim(), state: f.state.value.trim(), pincode: f.pincode.value.trim()
    };
  }
  function validate(c) {
    if (c.name.length < 2) return 'Please add your name.';
    if (!/^\+91[6-9]\d{9}$/.test(c.phone)) return 'Please enter a 10-digit Indian mobile number.';
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)) return 'Please enter a valid email.';
    if (!c.address1 || !c.city || !c.state) return 'Please complete the address.';
    if (!/^\d{6}$/.test(c.pincode)) return 'Pincode should be 6 digits.';
    return '';
  }
  function busy(on, label) {
    state.busy = on;
    els.pay.disabled = on;
    els.pay.textContent = on ? (label || 'One moment…') : root.dataset.payText || 'Confirm & pay';
  }
  function post(path, body) {
    return fetch(cfg.api + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) {
      return r.text().then(function (t) {
        var d = null; try { d = t ? JSON.parse(t) : null; } catch (e) {}
        if (!r.ok) { var err = new Error((d && d.error) || 'Something went wrong. Please try again.'); err.code = d && d.error; err.status = r.status; throw err; }
        return d;
      });
    });
  }

  els.form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.busy) return;
    var c = customer(), msg = validate(c);
    els.error.textContent = msg;
    if (msg) return;
    var p = plan();
    var payload = {
      planKey: p.key, pack: p.pack, cadenceWeeks: p.cadence === '2w' ? 2 : 4,
      // One line per box: the chosen flavour's variant (or the Assorted Pack's),
      // qty counted in cans. The backend maps this to Shopify line items.
      flavours: (function () {
        var card = flavourCard();
        return [{ handle: card.dataset.product || card.dataset.handle, variantId: card.dataset.variantId, sku: card.dataset.sku, qty: p.pack, assorted: card.dataset.kind === 'assorted' }];
      })(),
      customer: c,
      source: new URLSearchParams(location.search).get('src') || 'web',
      shopDomain: cfg.shop
    };

    if (seatsFull()) {
      busy(true, 'Saving…');
      (cfg.mock ? Promise.resolve({ ok: true }) : post('/api/subscriptions/waitlist', payload)).then(function () {
        els.summary.textContent = 'You\'re on the list. We\'ll message you the moment a seat opens.';
        els.form.hidden = true;
      }).catch(function (err) { els.error.textContent = err.message; }).then(function () { busy(false); });
      return;
    }

    if (cfg.mock) {
      busy(true, 'Mock: would open Razorpay…');
      setTimeout(function () { busy(false); els.error.textContent = 'Mock backend is on. Turn it off in the theme editor to pay for real.'; }, 800);
      return;
    }

    busy(true, 'Setting up…');
    post('/api/subscriptions/create', payload).then(function (d) {
      if (!window.Razorpay) throw new Error('Payment window could not load. Please refresh and try again.');
      busy(true, 'Opening Razorpay…');
      var rzp = new window.Razorpay({
        key: d.keyId,
        subscription_id: d.razorpaySubId,
        name: 'Uncanned',
        description: d.description || (p.pack + ' cans ' + cadenceLabel(p.cadence)),
        image: 'https://www.uncanned.in/cdn/shop/files/un-favicon-green-512.png?width=256&height=256',
        prefill: { name: c.name, email: c.email, contact: c.phone },
        notes: { planKey: p.key, subscriptionId: d.subscriptionId },
        theme: { color: '#bd6537' },
        modal: { ondismiss: function () { busy(false); } },
        handler: function (resp) {
          busy(true, 'Confirming…');
          post('/api/subscriptions/verify', {
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_subscription_id: resp.razorpay_subscription_id,
            razorpay_signature: resp.razorpay_signature
          }).then(function (v) {
            location.href = (v && v.orderUrl) || '/account/orders';
          }).catch(function () {
            busy(false);
            els.error.textContent = 'Payment went through but we could not confirm it. Don\'t pay again — message us on WhatsApp with ' + resp.razorpay_payment_id + '.';
          });
        }
      });
      rzp.on('payment.failed', function (r) {
        busy(false);
        els.error.textContent = (r && r.error && r.error.description) || 'Payment did not go through. Nothing was charged.';
      });
      rzp.open();
    }).catch(function (err) {
      busy(false);
      if (err.code === 'seats_full') { state.seatsLeft = 0; render(); els.error.textContent = 'The first lot just filled up. Submit again to join the list.'; return; }
      els.error.textContent = err.message;
    });
  });
})();
